import * as React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { white } from "styles/colors";
import { useTranslation } from "react-i18next";
import logo from "img/logo.svg";
import { blue } from "styles/colors";
import { Grid } from "@material-ui/core";
import { useAuth } from "data/auth/hooks";
import MenuBar from "components/HeaderMenuBar";

export const useStyles = makeStyles(() => ({
  headerTextAndLogo: {
    width: "100%",
    height: "4.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: white,
    position: "sticky",
    zIndex: 100,
  },
  headerText: {
    fontSize: "1.7rem",
    lineHeight: "1.875rem",
    marginTop: "0.75rem",
  },
  sidebar: {
    backgroundColor: blue,
    width: "1.3rem",
    padding: ".5rem",
  },
  headerBox: {
    padding: "0 11%",
    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
    zIndex: 200,
  },
  logoImage:{
    paddingRight: "0.2rem",
  }
}));

const Header: React.FC = () => {
  const [t] = useTranslation();
  const classes = useStyles();
  const [{ isAuthenticated }] = useAuth();
  return (
    <Grid container direction="row" wrap="nowrap" spacing={0}>
      <Grid item className={classes.sidebar}></Grid>
      <Grid item xs className={classes.headerBox}>
        <header className={classes.headerTextAndLogo}>
          <Typography className={classes.headerText} color="textPrimary">
            {t("common.appName")}
          </Typography>
          <img src={logo} className={classes.logoImage} alt="logo" width="208" />
        </header>
        <MenuBar />
      </Grid>
    </Grid>
  );
};

export default Header;
